module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright",
    attrs: {
      "id": "cop"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("Copyright © 1991 by Palomar S.r.l.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Translation copyright © 1999 by Jonathan Cape")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ALL RIGHTS RESERVED")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "pubhlink",
    attrs: {
      "href": "http://www.hmhco.com/popular-reading",
      "target": "_blank"
    }
  }, [_vm._v("www.hmhco.com")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("First published in Italy as "), _c('em', [_vm._v("Perché leggere i classici")]), _vm._v(" by Arnoldo Mondadori Editore, 1991")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("This translation first published in the United Kingdom by Jonathan Cape, London, and subsequently in the United States by Pantheon Books, a division of Penguin Random House, in 1999. First published in paperback by Vintage Books, a division of Penguin Random House, in 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Library of Congress Cataloging-in-Publication Data is available.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("ISBN: 978-0-544-14637-2")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("eISBN: 978-0-544-23086-6"), _c('br'), _vm._v("v1.1214")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e6f7488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Calv_9780307549310_epub_cop_r1.vue
// module id = 63
// module chunks = 0